export const httpError4XXCodes = new Set([404])
export const httpError5XXCodes = new Set([500, 501, 502, 503, 504, 505, 506, 507, 509, 510])
